/**
 * @generated SignedSource<<0270e91fe9b40f0c220311098a2407ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeviceScheduleScreen_DeleteMutation$variables = {
  deviceScheduleItemId: string;
};
export type DeviceScheduleScreen_DeleteMutation$data = {
  readonly deleteDeviceScheduleItem: {
    readonly deviceScheduleItem: {
      readonly id: string;
    };
  };
};
export type DeviceScheduleScreen_DeleteMutation = {
  response: DeviceScheduleScreen_DeleteMutation$data;
  variables: DeviceScheduleScreen_DeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "deviceScheduleItemId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "deviceScheduleItemId",
        "variableName": "deviceScheduleItemId"
      }
    ],
    "concreteType": "DeleteDeviceScheduleItemPayload",
    "kind": "LinkedField",
    "name": "deleteDeviceScheduleItem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DeviceScheduleItem",
        "kind": "LinkedField",
        "name": "deviceScheduleItem",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeviceScheduleScreen_DeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeviceScheduleScreen_DeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "819f17e1169ba03c174074947fb3b4ea",
    "id": null,
    "metadata": {},
    "name": "DeviceScheduleScreen_DeleteMutation",
    "operationKind": "mutation",
    "text": "mutation DeviceScheduleScreen_DeleteMutation(\n  $deviceScheduleItemId: ID!\n) {\n  deleteDeviceScheduleItem(deviceScheduleItemId: $deviceScheduleItemId) {\n    deviceScheduleItem {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fe3161a687e27564f51ce10286ec6231";

export default node;
